import { CopyOutlined, MoreOutlined } from "@ant-design/icons";
import { Popover, List, Typography, Button } from "antd";
import React, { useState } from "react";
import "./orderCard.scss";
import DynamicModal from "../../commonComponents/DynamicModal/DynamicModal";
const { Text, Link } = Typography;
const OrderCard = (props) => {
  const [openModel, setOpenModel] = useState(false);
  
  const closeModal = () => {
    setOpenModel(false);
  };
  
  const content = (
    <>
      <div>
        {/* <UnorderedListOutlined /> */}
        <Text
          className="popover_links"
          onClick={() => props.goToBookingDetails(props.key)}
        >
          {" "}
          Assign Studio
        </Text>
      </div>
      <div>
        {/* <FileExcelOutlined  /> */}
        <Text
          className="popover_links"
          onClick={() => props.showManageCsvDetails()}
        >
          {" "}
          Manage CSV
        </Text>
      </div>
      {props.ddURL && (
        <div>
          <Link
            className="dd_link popover_links"
            href={props.ddURL}
            target="_blank"
          >
            View Deliverable Deck
          </Link>
        </div>
      )}
      <div>
        <Text className="popover_links" onClick={() => setOpenModel(true)}>
          {" "}
          View Shooting Guidelines
        </Text>
      </div>
      <div>
        <Text
          className="popover_links"
          onClick={() => props.goToBookingDetails(props.key)}
        >
          {" "}
          Order Details
        </Text>
      </div>
    </>
  );
  return (
    <div className="order_card_layout">
      <div className="order_details">
        <div>
          <h5 className="text-center">Batch No.</h5>
          <span className="card_subtitle">{props.srNo}</span>
        </div>
        <div>
          <h5 className="text-center">Client</h5>
          <span className="card_subtitle">{props.clientName}</span>
        </div>
        <div>
          <h5 className="text-center">Order Name</h5>
          <span className="card_subtitle">{props.orderName}</span>
        </div>
      </div>
      <div>
        <div className="icon_legend">
          <Popover placement="left" content={content} trigger="click" 
          >
            <MoreOutlined />
          </Popover>
        </div>

        <div
          style={{
            display: "flex",
          }}
        >
          <h5 className="legend_text">Booking Date - </h5>
          <h5 className="legend_text">
            {props.bookingDate &&
              new Date(props.bookingDate).toLocaleDateString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
          </h5>
        </div>
      </div>
      <DynamicModal
        open={openModel}
        close={closeModal}
        closable
        title="Shooting Guidelines Links"
        component={(<List
          itemLayout="horizontal"
          dataSource={props.sglURLs}
          renderItem={(link, i) => (
            <List.Item>
              <List.Item.Meta
                title={`open link ${i + 1}:`}
                description={
                  <a href={link} target="_blank" rel="noreferrer">
                    {link}
                  </a>
                }
              />
              <CopyOutlined className="copy_link"  onClick={()=>navigator.clipboard.writeText(link)}/>
            </List.Item>
          )}
        />)}
      />
    </div>
  );
};

export default OrderCard;
